// extracted by mini-css-extract-plugin
module.exports = {"flag":"Flag_flag__G5Q9N"};